import { guideItems } from "@/mocks/content";

const compare = [
  { key: "完整版", desc: "强调时间线连贯的成片顺序", focus: "想一次看完整故事" },
  { key: "短剧", desc: "单集更短、冲突更集中", focus: "时间零散、想快速进入剧情" },
  { key: "看全集", desc: "按顺序完整观看全部集数", focus: "已经决定追完一部" },
  { key: "未删减", desc: "内容未经剪辑处理的版本", focus: "关注细节与完整度" },
];

export default function GuideSection() {
  return (
    <section id="guide" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="max-w-2xl" data-reveal>
          <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950">
            观看指南：完整版、短剧、看全集与未删减
          </h2>
          <p className="mt-3 text-foreground-600 leading-8">
            观看前先确认版本与顺序，可以省下不少来回查找的时间。下面先给出四组概念的对照，
            再补充具体的播放与阅读建议。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-reveal>
          {compare.map((c) => (
            <div
              key={c.key}
              className="p-5 rounded-xl bg-accent-50 border border-accent-200"
            >
              <h3 className="font-heading font-semibold text-foreground-950 text-base">{c.key}</h3>
              <p className="mt-2 text-sm text-foreground-700 leading-6">{c.desc}</p>
              <p className="mt-3 text-xs text-accent-800 inline-flex items-center gap-1.5">
                <i className="ri-flag-line" aria-hidden="true"></i>
                适合：{c.focus}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-4">
          {guideItems.map((g) => (
            <div
              key={g.title}
              data-reveal
              className="flex items-start gap-4 p-5 rounded-xl bg-background-100 border border-background-200"
            >
              <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className={`${g.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-medium text-foreground-900">{g.title}</h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-7">{g.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}